import { ColorTokens, InputTypeToken, } from '@voltmoney/schema';
import { inputTypeTokensMap as inputTypeTokensMapLight } from '../../light-mobile/textInput';
export const inputTypeTokensMap = {
    [InputTypeToken.DEFAULT]: {
        ...inputTypeTokensMapLight.DEFAULT,
        color: ColorTokens.Grey_100,
        borderColor: ColorTokens.Grey_400,
    },
    [InputTypeToken.EMAIL]: {
        ...inputTypeTokensMapLight.EMAIL,
        color: ColorTokens.Grey_100,
        bgColor: ColorTokens.Grey_550,
    },
    [InputTypeToken.MOBILE]: {
        ...inputTypeTokensMapLight.MOBILE,
        color: ColorTokens.Grey_100,
        bgColor: ColorTokens.Grey_600,
    },
    [InputTypeToken.OTP]: {
        ...inputTypeTokensMapLight.OTP,
        color: ColorTokens.Grey_100,
        bgColor: ColorTokens.Grey_600,
    },
    [InputTypeToken.SEARCH]: {
        ...inputTypeTokensMapLight.SEARCH,
        color: ColorTokens.Grey_100,
        bgColor: ColorTokens.Grey_600,
    },
    [InputTypeToken.MULTILINE]: {
        ...inputTypeTokensMapLight.SEARCH,
        color: ColorTokens.Grey_100,
        bgColor: ColorTokens.Grey_600,
    },
    // [InputTypeToken.CALENDAR]: {
    // 	...inputTypeTokensMapLight.SEARCH,
    // 	color: ColorTokens.Grey_100,
    // 	bgColor: ColorTokens.Grey_600,
    // },
};
